import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { IDWSession } from "@idw-types/data/idw-session";
import { handleRequest } from "@utils/http-util";

export const getSessionRequest = async (): Promise<{ data: IDWSession, error: any }> => {
    const route = apiRoutes.axnadminCore.session;
    const { data, error } = await handleRequest(RequestTypes.GET, route);

    let finalData = data;
    if (data) {
        const limits = {
            relyingParties: data.limits.relyingParties || 900000000,
            rpServices: data.limits.rpServices || 900000000,
            workflows: data.limits.workflows || 900000000
        };

        finalData = {
            ...data,
            limits
        };
    }

    return {
        data: finalData,
        error
    };
};